"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  1: { // L
    0: 0,
    1: 0,
    2: 0,
    3: 0xff
  },
  2: { // LA
    0: 0,
    1: 0,
    2: 0,
    3: 1
  },
  3: { // RGB
    0: 0,
    1: 1,
    2: 2,
    3: 0xff
  },
  4: { // RGBA
    0: 0,
    1: 1,
    2: 2,
    3: 3
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/pngjs3/dist/dataToBitMap/pixelBppMap.js
// module id = 456
// module chunks = 0